import { useEffect, useRef } from 'react';
import { registerConsentHandler } from './registry';
import type { ConsentHandler } from './types';

/**
 * Registers a service consent handler tied to the component lifecycle. The latest handler is always invoked (via a ref) so inline closures stay current without re-registering.
 */
export const useConsentHandler = (id: string, handler: ConsentHandler): void => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => registerConsentHandler(id, (snapshot) => handlerRef.current(snapshot)), [id]);
};
